import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_07dd2ee2-42aa-4d8a-a966-79b38cca8e94/artifacts/skr2sta7_Logo.png";
const HERO_BG = "https://images.unsplash.com/photo-1704253797699-f983e3cd70ff?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80";

export const Hero = () => {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-screen flex items-center justify-center overflow-hidden"
        >
            {/* Background Image */}
            <div className="absolute inset-0">
                <img
                    src={HERO_BG}
                    alt=""
                    className="w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-brand-bg/50 to-transparent" />
            </div>

            {/* Smoke Effects */}
            <div className="absolute bottom-0 left-1/4 smoke-effect animate-smoke" style={{ animationDelay: '0s' }} />
            <div className="absolute bottom-0 right-1/3 smoke-effect animate-smoke" style={{ animationDelay: '2s' }} />
            <div className="absolute bottom-0 left-1/2 smoke-effect animate-smoke" style={{ animationDelay: '4s' }} />

            {/* Content */}
            <div className="relative z-10 text-center px-6">
                <img
                    src={LOGO_URL}
                    alt="StillFaded"
                    className="w-64 md:w-80 mx-auto mb-8 animate-float"
                    data-testid="hero-logo"
                />
                <h1 className="font-syne font-extrabold text-5xl md:text-7xl lg:text-8xl text-white tracking-tighter uppercase mb-6 animate-fadeInUp">
                    FADED KEENAN
                </h1>
                <p className="font-space text-slate-400 text-lg md:text-xl max-w-xl mx-auto mb-10 animate-fadeInUp stagger-1">
                    Hip-hop • Neo-soul • Indie Pop
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeInUp stagger-2">
                    <Link to="/music">
                        <Button
                            data-testid="hero-listen-btn"
                            className="bg-white text-black hover:bg-slate-200 rounded-none px-8 py-6 font-bold uppercase tracking-widest"
                        >
                            <Play className="w-4 h-4 mr-2" /> LISTEN NOW
                        </Button>
                    </Link>
                    <Link to="/merch">
                        <Button
                            data-testid="hero-shop-btn"
                            variant="outline"
                            className="bg-transparent border border-white/20 text-white hover:bg-white/10 rounded-none px-8 py-6 uppercase tracking-widest backdrop-blur-sm"
                        >
                            SHOP MERCH
                        </Button>
                    </Link>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
                <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
                    <div className="w-1 h-2 bg-white/50 rounded-full" />
                </div>
            </div>
        </section>
    );
};
